module.exports = __webpack_public_path__ + "img/access-control.6481295f.jpeg";